module.exports = __webpack_public_path__ + "static/media/two_monkey_cuttingwood.e2a3e606.gif";